module.exports = __webpack_public_path__ + "static/media/spinner.e8d35990.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/spinner.png
 ** module id = 471
 ** module chunks = 0
 **/